import type { LiveGame } from "@/local-shared/model";
import { type SocialAPI } from ".";
import HTTPStatus from "@/realize-shared/HTTPStatus";

export default class SearchAPI
{
    public constructor(private api: SocialAPI)
    {

    }

    public async liveGames(): Promise<{
        status: HTTPStatus;
        message: string;
        data?: LiveGame[]
    }>
    {
        const res = await this.api.fetch<LiveGame[]>("/search/live");

        if (res.status !== HTTPStatus.OK)
        {
            Logger.log("Live Games", res.data);

            return {
                status: res.status as HTTPStatus,
                message: res.message,
            };
        }

        return {
            status: HTTPStatus.OK,
            message: "Live games retrieved successfully.",
            data: res.data,
        };
    }
}
